module.exports = __webpack_public_path__ + "img/hibernians.51abdc6e.png";